import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import { Row, Col, Form, Icon } from 'antd';

import Button from 'components/Button/Button';
import GoogleMapsSearch from 'components/GoogleMapsSearch/GoogleMapsSearch';

import MobileBackgroundImage from './images/mobile-bg.svg';
import WebBackgroundImage from './images/web-bg.svg';

const WrappedGoogleMapsSearch = Form.create()(GoogleMapsSearch);
WrappedGoogleMapsSearch.displayName = 'WrappedGoogleMapsSearch';

const MainContainer = styled(Row)`
  background: url(${MobileBackgroundImage}) no-repeat center bottom;
  background-size: cover;
  display: block;
  width: 100%;
  min-height: 648px;

  @media (min-width: 768px) {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    background: url(${WebBackgroundImage}) no-repeat center bottom;
    background-size: cover;
  }

  @media (min-width: 1600px) {
    background: url(${WebBackgroundImage}) no-repeat center bottom;
    background-size: cover;
    height: 80vh !important;
  }
`;

const IntroductionVideo = () => {
  const [iframeWidth, setIframeWidth] = useState(0);
  const iframeRef = createRef();

  useEffect(() => {
    const onWindowResize = () => {
      setIframeWidth(iframeRef.current.offsetWidth);
    };

    window.addEventListener('resize', onWindowResize);
    onWindowResize();

    return () => window.removeEventListener('resize', onWindowResize);
  }, [iframeRef]);

  return (
    <iframe
      ref={iframeRef}
      title="HostAStay - Malaysia's Largest Short Stay Directory Platform"
      width="100%"
      height={iframeWidth ? `${iframeWidth * 0.5625}` : '0'}
      src="https://www.youtube.com/embed/2AorfTchWlY"
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};

const Search = () => {
  const [searchText, onSearchChange] = useState('');

  const handleOnInputChange = e => {
    const inputValue = e.target.value || '';

    onSearchChange(inputValue);
  };

  const handleOnPlaceChange = place => {
    onSearchChange(place.addressDisplayed);
  };

  const handleOnSearch = () => {
    if (searchText) {
      window.location.href = `/search-host?address=${searchText}`;
    } else {
      window.location.href = `/search-host`;
    }
  };

  return (
    <MainContainer>
      <Col span={24} md={18} lg={16} xl={12}>
        <Row style={{ marginBottom: '16px' }}>
          <Col span={24}>
            <IntroductionVideo />
          </Col>
        </Row>
        <Row>
          <Col span={18} md={20}>
            <WrappedGoogleMapsSearch
              onPlaceChange={handleOnPlaceChange}
              onInputChange={handleOnInputChange}
              defaultValue={''}
              style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            />
          </Col>
          <Col span={6} md={4}>
            <Button type="landing-search" onClick={() => handleOnSearch()} round="true">
              <Icon type="search" style={{ fontSize: '18px' }} />
            </Button>
          </Col>
        </Row>
      </Col>
    </MainContainer>
  );
};

export default Search;
